<script>
    import { createEventDispatcher } from 'svelte'
    import { get } from 'dot-prop'
    import { InputGroup, InputGroupText, InputGroupAddon, FormGroup, Input, Label } from 'sveltestrap'
    import Required from './Required.svelte'
    import ValidationMessage from './ValidationMessage.svelte'

    export let context
    export let formKey
    export let index
    export let keypath // The keypath without the formKey or index, e.g. "attributes.videos.3.url"
    export let value
    export let label
    export let placeholder = label
    export let required
    export let helptext
    export let prepend

    $: formKeypath = index === undefined ? `${formKey}.${keypath}` : `${formKey}.${index}.${keypath}`
    $: isInvalid = get(context, `error.${formKeypath}.level`) === 'error'

    const dispatch = createEventDispatcher()
    const update = (event) => {
        dispatch('change', { formKey, index, keypath, value: event.target.value, context })
    }
</script>

<FormGroup>
    <Label for={formKeypath}>
        {label || ''}
        <Required {required} />
    </Label>

    {#if prepend}
        <InputGroup>
            <InputGroupAddon addonType="prepend">
                <InputGroupText>{prepend}</InputGroupText>
            </InputGroupAddon>
            <Input id={formKeypath} name={formKeypath} {placeholder} {isInvalid} bind:value on:input={update} />
        </InputGroup>
    {:else}
        <Input id={formKeypath} name={formKeypath} {placeholder} {isInvalid} bind:value on:input={update} />
    {/if}

    <ValidationMessage {context} {formKeypath} {helptext} />
</FormGroup>
